import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import oidcConfig from "./models/config/oidc-config";

function onSigninCallback(state : any) {
  const redirectPath = sessionStorage.getItem('redirectPath');
  if (redirectPath) {
    const queryParams = sessionStorage.getItem('queryParams');
    const redirectUrl = (redirectPath === null || redirectPath === "/") ? "/" : `${redirectPath}/${queryParams}`;
    sessionStorage.removeItem('redirectPath');
    sessionStorage.removeItem('queryParams');
    window.location.href = redirectUrl;
  }
  else {
    window.location.href = "/";
  }
}

const container = document.getElementById("root")!;
const root = createRoot(container);

const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback} automaticSilentRenew={false}>
          <QueryClientProvider client={queryClient}> 
            <App />
          </QueryClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
